// extracted by mini-css-extract-plugin
module.exports = {"container":"privacy_container__2Uwz_","innercontainer":"privacy_innercontainer__lp0Vx"};